const PATHS = {
  mic: (
    <>
      <path d="M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3z" />
      <path d="M19 11a7 7 0 0 1-14 0" />
      <path d="M12 18v3" />
    </>
  ),
  send: (
    <>
      <path d="M12 19V5" />
      <path d="M5.5 11.5 12 5l6.5 6.5" />
    </>
  ),
  x: <path d="M6 6l12 12M18 6 6 18" />,
  bulb: (
    <>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M12 3a6 6 0 0 0-3.6 10.8c.7.5 1.1 1.3 1.1 2.1V16h5v-.1c0-.8.4-1.6 1.1-2.1A6 6 0 0 0 12 3z" />
    </>
  ),
  swap: (
    <>
      <path d="M16 3l4 4-4 4" />
      <path d="M20 7H9" />
      <path d="M8 21l-4-4 4-4" />
      <path d="M4 17h11" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  play: (
    <path
      d="M8 5.6v12.8a.8.8 0 0 0 1.2.7l10-6.4a.8.8 0 0 0 0-1.4l-10-6.4A.8.8 0 0 0 8 5.6z"
      fill="currentColor"
      stroke="none"
    />
  ),
  pause: (
    <>
      <rect
        x="7"
        y="5"
        width="3.5"
        height="14"
        rx="1"
        fill="currentColor"
        stroke="none"
      />
      <rect
        x="13.5"
        y="5"
        width="3.5"
        height="14"
        rx="1"
        fill="currentColor"
        stroke="none"
      />
    </>
  ),
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  plus: <path d="M12 5v14M5 12h14" />,
  volume: (
    <>
      <path d="M4 9.5v5h3.5L12 18V6L7.5 9.5z" fill="currentColor" />
      <path d="M15.5 9a4 4 0 0 1 0 6" />
      <path d="M18 6.5a7.5 7.5 0 0 1 0 11" />
    </>
  ),
  warn: (
    <>
      <path d="M12 4 2.8 19.5h18.4z" />
      <path d="M12 10v4" />
      <path d="M12 17v.01" />
    </>
  ),
  chat: (
    <>
      <path
        d="M12 3c5 0 9 3.4 9 7.6s-4 7.6-9 7.6c-1 0-2-.1-2.9-.4L4.5 20l1.2-3.6C4 15 3 12.9 3 10.6 3 6.4 7 3 12 3z"
        fill="currentColor"
        stroke="none"
      />
      <circle cx="8.3" cy="10.6" r="1.2" fill="#655A8E" stroke="none" />
      <circle cx="12" cy="10.6" r="1.2" fill="#655A8E" stroke="none" />
      <circle cx="15.7" cy="10.6" r="1.2" fill="#655A8E" stroke="none" />
    </>
  ),
}

export type FtIconName = keyof typeof PATHS

export function FtIcon(props: {
  name: FtIconName
  size?: number
  stroke?: number
}) {
  const size = props.size ?? 20
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={props.stroke ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[props.name]}
    </svg>
  )
}
